<script setup lang="ts">
/**
 * UI-kit component
 * Category: Buttons
 * Name: BtnLinkId
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=8144-123320&t=Q08xSIR99kih0t0I-4
 */
import type { BtnLinkIdProps } from '../types/interfaces'

import { AppText } from '@shared/ui/typography'
import { AppTooltip } from '@shared/ui/tooltips'

import { useBtnLinkId } from '../composables/use-btn-link-id.hook'

defineOptions({
  name: 'BtnLinkId',
})

const props = withDefaults(defineProps<BtnLinkIdProps>(), {
  text: 'ID',
  disabled: false,
  tooltipText: 'Copy ID:',
})

const {
  refIsSupported,
  refTooltipText,
  setCopy,
} = useBtnLinkId({ props })
</script>

<template>
  <div
    v-if="refIsSupported"
    class="btn-link-id"
  >
    <AppTooltip
      v-if="refTooltipText"
      :text="refTooltipText"
    >
      <button
        type="button"
        class="btn-link-id__btn"
        :disabled="disabled"
        @click="setCopy"
      >
        <AppText name="body1">
          {{ text }}
        </AppText>
      </button>
    </AppTooltip>
    <button
      v-else
      type="button"
      class="btn-link-id__btn"
      :disabled="disabled"
      @click="setCopy"
    >
      <AppText name="body1">
        {{ text }}
      </AppText>
    </button>
  </div>
</template>

<style lang="scss" scoped src="../styles/_btn-link-id.scss" />
